import React, { useState, useEffect } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  //DropdownItem,
  // NavbarText,
  Input,
  NavLink,
  Form,
  Row,
  Col,
  FormGroup,
  Modal,
  ModalBody
} from "reactstrap";
import TabPanel from "../loginRegisterTab";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CustomDropdown from "../customDropdown";
import { ComonIcons } from "../../contents/commonIcons";
import { withNamespaces } from "react-i18next";
import i18n from "../../i18n";
import { history } from "../../app/AppRouter";
import { setCountry } from "../../redux/actions/login/loginAction";
import ReactFlagsSelect from "react-flags-select";
import {
  loginApi,
  logoutApi,
  forgotPasswordApi,
  resetPasswordApi,
  notificationApi,
  unreadNotificationCountApi,
  markReadApi,
  setLanguageType,
  setDirectionType,
  setLoginModalState,
  declineClassBooking,
  addReviewApi
} from "../../redux/actions/api/apiAction";
import { setRatingModal } from "../../redux/actions/modal/modalAction";
import { setCountryPopup } from "../../redux/actions/languageDirection/languageDirectionAction";
import { store } from "../../redux/storeConfig/store";
import { v4 as uuidv4 } from "uuid";
import SaudiFlag from "../../assets/images/Saudi.png";
import USAFlag from "../../assets/images/USA.png";
import UserImage from "./userImage";
const listitems = [
  {
    innertitle: "English",
    code: "en",
    img: USAFlag
  },
  {
    innertitle: "العربية",
    code: "ar",
    img: SaudiFlag
  }
];
const Header = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState(props.loginModal);
  // const [reviewModal, setReviewModal] = useState(props.ratingModal);
  const [star, setStar] = useState(1);
  const [eye, setEye] = useState(false);
  const [forgetModal, setForgetModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [email, setEmail] = useState(false);
  const [regionModal, setRegionModal] = useState(false);
  const [region, setSelectedRegion] = useState(props.country);
  const [reviewDetails, setReviewDetails] = useState(props.country);

  useEffect(() => {
    async function fetchNotification() {
      await store.dispatch(notificationApi());
      await store.dispatch(unreadNotificationCountApi());
    }
    if (props.loginFlag) fetchNotification();
    if (!props.country && props.showCountryPopup) {
      setRegionModal(true);
    }
  }, []);

  const toggle = () => setIsOpen(!isOpen);
  const settoggle = () =>
    store.dispatch(
      setRatingModal({ flag: !props.ratingModal, id: "", type: "" })
    );

  const changeLanguage = async lng => {
    i18n.changeLanguage(lng);
    if (lng === "en") {
      await store.dispatch(setLanguageType("en"));
      await store.dispatch(setDirectionType("ltr"));
    } else {
      await store.dispatch(setLanguageType("ar"));
      await store.dispatch(setDirectionType("rtl"));
    }
  };
  const toggleModal = () => {
    // console.log("this callesd");
    // setModal(!modal);
    store.dispatch(setLoginModalState(!props.loginModal));
  };
  const forgetToggle = () => {
    setForgetModal(!forgetModal);
  };
  const otpToggle = () => {
    setOtpModal(!otpModal);
  };

  const toggleRegionModal = () => {
    if (regionModal) {
      // localStorage.setItem("showCountryPopup", false);
      store.dispatch(setCountryPopup(false));
    }
    setRegionModal(!regionModal);
  };

  const setRegion = value => {
    // setSelectedRegion(region);
    store.dispatch(setCountry(value));
    localStorage.setItem("country", value);
  };

  const clearSelectedCountry = () => {
    store.dispatch(setCountry(""));
    localStorage.removeItem("country");
    setSelectedRegion("");
  };

  const toggleEye = () => {
    setEye(!eye);
  };

  const submitLogin = async (email, password) => {
    // console.log(email, password, "password during login");
    await store.dispatch(loginApi({ email: email, password: password }));
  };

  const logout = async () => {
    await store.dispatch(
      logoutApi(JSON.parse(localStorage.getItem("connectToFitWebsiteUser")).id)
    );
  };

  const handleForgotSubmit = async email => {
    // console.log("Here", email);
    // await store.dispatch(loginApi({email : email, password : password}));
    setEmail(email);
    let response = await store.dispatch(forgotPasswordApi(email));
    forgetToggle();
    if (response) {
      otpToggle();
    }
  };
  const handleOtpSubmit = async otp => {
    // console.log("Here", email);
    let data = {
      email: email,
      otp: otp,
      password: uuidv4().substr(0, 12)
    };
    await store.dispatch(resetPasswordApi(data));
  };

  const declineBooking = async classId => {
    await store.dispatch(declineClassBooking(classId));
  };

  const openReviewModal = value => {
    store.dispatch(
      setRatingModal({ flag: true, id: value.from, type: value.fromType })
    );
  };

  const handleReviewDetailChange = e => {
    // console.log(e.target.value);
    setReviewDetails(e.target.value);
  };

  const getNotificationLink = one => {
    console.log("one", one);
    switch (one.type) {
      case "CLASS_BOOKED":
        return (
          <Link to={"/userinfo"} className="h5 mb-0 mt-2 f-bold">
            {props.t("view_classes")}
          </Link>
        );
      case "SLOT_OPEN":
        return (
          <Link
            to={`/checkout/${one.targetId}`}
            className="h5 mb-0 mt-2 f-bold"
          >
            {props.t("book")}
          </Link>
        );
      case "CLASS_BOOKED_BY_ADMIN":
        return (
          <Link
            onClick={() => declineBooking(one.targetId)}
            className="h5 mb-0 mt-2 f-bold"
          >
            {props.t("decline")}
          </Link>
        );
      case "GIVE_REVIEW":
        return (
          <Link
            onClick={() => openReviewModal(one)}
            className="h5 mb-0 mt-2 f-bold"
          >
            {props.t("add_review")}
          </Link>
        );
      default:
        return "";
    }
  };

  const handleMarkRead = async id => {
    await store.dispatch(markReadApi(id));
    await store.dispatch(notificationApi());
    await store.dispatch(unreadNotificationCountApi());
  };
  // const toggleRegionModal = () =>{
  //   setRegionModal(!regionModal);
  // }
  // const setRegion = (value) =>{
  //   // setSelectedRegion(region);
  //   store.dispatch(setCountry(value));
  //   localStorage.setItem('country', value);
  // }

  const handleReviewSubmit = async () => {
    let data = {
      star: star,
      details: reviewDetails
    };
    if (props.type === "G") data.gym = props.id;
    else data.trainer = props.id;
    await store.dispatch(addReviewApi(data));
    settoggle();
  };

  var user = JSON.parse(localStorage.getItem("connectToFitWebsiteUser"));

  return (
    <div className="header">
      <div className="header-first-block px-0 ">
        <div className="custom-container">
          <div className="d-block d-sm-flex align-items-center">
            <div className="header-first-list">
              <ul className="list-block">
                <li className="list-block-element">
                  <Link
                    className={`a-block
                  ${
                    history.location.pathname === "/customer"
                      ? "active"
                      : "null"
                  }
                  `}
                    to={"/customer"}
                  >
                    {props.t("user")}
                  </Link>
                </li>
                <li
                  className="list-block-element"
                  onClick={() =>
                    //  window.open("https://app.connecttofit.zignuts.dev/", "_blank")
                    history.push("/enterprise")
                  }
                >
                  <Link
                    className={`a-block 
                   ${
                     history.location.pathname === "/enterprise"
                       ? "active"
                       : "null"
                   }
                  `}
                    // to={"/enterprise"}
                  >
                    {props.t("business")}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="ml-auto my-2 my-sm-0">
              <div className="d-flex align-items-center">
                <div className="d-inlin-flex mr-2 position-relative">
                  <ReactFlagsSelect
                    searchable
                    countries={["JO", "SA", "AE", "EG"]}
                    selected={region}
                    placeholder={props.t("select_country")}
                    searchPlaceholder={props.t("search")}
                    onSelect={val => {
                      setRegion(val);
                      setSelectedRegion(val);
                    }}
                    className="pb-0 position-relative"
                  />
                  <div
                    className={`close-language ${region ? "show" : ""}`}
                    onClick={() => clearSelectedCountry()}
                  >
                    {ComonIcons.close}
                  </div>
                </div>
                <div className="d-inlin-flex">
                  <CustomDropdown
                    uniqueClass="navbar-language"
                    dropdownitems={listitems}
                    maintitle="Language"
                    changeLanguage={changeLanguage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="header-second-block px-0">
        <div className="custom-container">
          <Navbar color="white" light expand="lg" className="px-0">
            <NavbarBrand
              className="c-pointer"
              onClick={() => history.push("/")}
            >
              <img src={require("../../assets/images/connecttofitlogo.svg")} />
            </NavbarBrand>
            <Nav className="ml-auto navbar-with-login mobile-view" navbar>
              {props.loginFlag && (
                <UncontrolledDropdown
                  className="navbar-notification-drp"
                  nav
                  inNavbar
                >
                  <DropdownToggle nav className="h5 mb-0">
                    <div className="position-relative">
                      {ComonIcons.notification}
                      {props.unreadNotificationCount > 0 ? (
                        <span className="notification-counter">
                          {props.unreadNotificationCount}
                        </span>
                      ) : null}
                    </div>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <div className="notification-block">
                      <ul className="notification-wrapper">
                        {props.notifications &&
                          props.notifications.map((one, index) => {
                            return (
                              <li
                                className={`notification-element  ${
                                  !one.isRead ? "active" : ""
                                }`}
                                id={index}
                                onClick={() => {
                                  if (!one.isRead) handleMarkRead(one.id);
                                  else return;
                                }}
                              >
                                <div className="notification-inner-wrapper">
                                  <div className="blk-1">
                                    <img
                                      className="img-fluid"
                                      src={
                                        one.avatar ||
                                        require("../../assets/images/event.jpg")
                                      }
                                    />
                                  </div>
                                  <div className="blk-2 flex-column">
                                    <h5 className="mb-0 notification-text  f-bold">
                                      {one.title}
                                      {/* <span>{!one.isRead ? null : <p>UnRead</p>}</span> */}
                                    </h5>
                                    {/* <Link className="h5 mb-0 mt-2 f-bold">
                                  Reserve Class Now{" "}
                                </Link> */}
                                    {getNotificationLink(one)}
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        {props.notifications &&
                        props.notifications.length <= 0 ? (
                          <div>
                            <p className="m-4">
                              {props.t("no_notification_available")}
                            </p>
                          </div>
                        ) : null}
                      </ul>
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              {props.loginFlag && (
                <UncontrolledDropdown
                  className="navbar-profile"
                  nav
                  inNavbar
                  caret
                >
                  <DropdownToggle nav className="h5 mb-0 p-0 mr-1">
                    <div className="profile-menu-link-block">
                      <UserImage />
                    </div>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <div className="notification-block">
                      <ul className="notification-wrapper">
                        <li
                          className="profile-link"
                          onClick={() => history.push("/userinfo")}
                        >
                          <div className="d-flex align-items-center">
                            <span className="blk-1">{ComonIcons.info}</span>{" "}
                            <span className="blk-2 f-bold mb-0">
                              {props.t("my-profile")}
                            </span>
                          </div>
                        </li>
                        <li
                          className=" profile-link"
                          onClick={() => history.push("/accountinfo")}
                        >
                          <div className="d-flex align-items-center">
                            <span className="blk-1">{ComonIcons.member}</span>{" "}
                            <span className="blk-2 f-bold mb-0">
                              {props.t("my-account-info")}
                            </span>
                          </div>
                        </li>
                        <li
                          className="profile-link"
                          onClick={() => history.push("/setting")}
                        >
                          <div className="d-flex align-items-center">
                            <span className="blk-1">{ComonIcons.setting}</span>{" "}
                            <span className="blk-2 f-bold mb-0">
                              {props.t("setting-privacy")}
                            </span>
                          </div>
                        </li>
                        <li className="profile-link" onClick={() => logout()}>
                          <div className="d-flex align-items-center">
                            <span className="blk-1">{ComonIcons.signout}</span>{" "}
                            <span className="blk-2 f-bold mb-0">
                              {props.t("sign-out")}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </Nav>

            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mr-auto" navbar>
                <NavItem>
                  <NavLink
                    onClick={() => history.push("/customer")}
                    active={history.location.pathname === "/customer"}
                  >
                    {props.t("home")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() => history.push("/gyms")}
                    active={history.location.pathname === "/gyms"}
                  >
                    {props.t("gyms")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() => history.push("/personaltrainer")}
                    active={history.location.pathname === "/personaltrainer"}
                  >
                    {props.t("personal-trainer")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() => history.push("/livestream")}
                    active={history.location.pathname === "/livestream"}
                  >
                    {props.t("live-stream")}
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    onClick={() => history.push("/equipment")}
                    active={history.location.pathname === "/equipment"}
                  >
                    {" "}
                    {"Home Gym & Equipments"}
                  </NavLink>
                </NavItem> */}
              </Nav>
              {!props.loginFlag ? (
                <Nav className="ml-auto " navbar>
                  <UncontrolledDropdown
                    className="navbar-login-drp"
                    nav
                    inNavbar
                  >
                    <DropdownToggle nav className="h5 mb-0">
                      {props.t("login_or_register")} {ComonIcons.info}{" "}
                    </DropdownToggle>
                    <DropdownMenu right>
                      <div className="navbar-login">
                        <div className="login-register-main-block">
                          <div className=" login-register">
                            {/* <div className="social-media-btn input-content-form p-0 ">
                              <div className="social-media-icon-tab">
                                <ul className="social-media-icon-block text-center">
                                  <li className="social-media-icon-btn">
                                    <button className="btn facebook">
                                      <span className="sp-text">Face Book</span>{" "}
                                      <span className="sp-icon">
                                        <i class="fa fa-facebook-square"></i>
                                      </span>
                                    </button>
                                  </li>
                                  <li className="social-media-icon-btn">
                                    <button className="btn twitter">
                                      <span className="sp-text">Twitter</span>{" "}
                                      <span className="sp-icon">
                                        <i class="fa fa-twitter-square"></i>
                                      </span>
                                    </button>
                                  </li>
                                  <li className="social-media-icon-btn">
                                    <button className="btn gmail">
                                      <span className="sp-text">Gmail</span>
                                      <span className="sp-icon">
                                        <i class="fa fa-google-plus-square"></i>
                                      </span>
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="or-blk">
                              <div className="or-absolute">
                                <h5 className="text-uppercase">
                                  {props.t("or")}
                                </h5>
                              </div>
                            </div> */}
                            <div className="input-content-form">
                              <Form
                                className="login-form"
                                onSubmit={e => {
                                  e.preventDefault();
                                  submitLogin(
                                    e.target.email.value,
                                    e.target.password.value
                                  );
                                }}
                              >
                                <Row>
                                  <Col md={12}>
                                    <FormGroup className="custom-inputs with-icon mb-2">
                                      <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        required
                                        maxLength={50}
                                        placeholder="Email"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <FormGroup className="custom-inputs with-icon mb-2">
                                      <Input
                                        type={eye ? "text" : "password"}
                                        name="password"
                                        id="password"
                                        minLength={8}
                                        placeholder="Password"
                                        required
                                      />
                                      <div className="icons">
                                        <svg
                                          id="eye"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="29.773"
                                          height="20.3"
                                          viewBox="0 0 29.773 20.3"
                                          onClick={() => toggleEye()}
                                        >
                                          <g
                                            id="Group_5705"
                                            data-name="Group 5705"
                                            transform="translate(0 0)"
                                          >
                                            <g
                                              id="Group_5704"
                                              data-name="Group 5704"
                                              transform="translate(0 0)"
                                            >
                                              <path
                                                id="Path_1"
                                                data-name="Path 1"
                                                d="M174.727,170.667a4.06,4.06,0,1,0,4.06,4.06A4.063,4.063,0,0,0,174.727,170.667Z"
                                                transform="translate(-159.84 -164.577)"
                                                fill="#17468f"
                                              />
                                              <path
                                                id="Path_2"
                                                data-name="Path 2"
                                                d="M14.887,74.667A16.006,16.006,0,0,0,0,84.817a15.992,15.992,0,0,0,29.773,0A16,16,0,0,0,14.887,74.667Zm0,16.917a6.767,6.767,0,1,1,6.767-6.767A6.769,6.769,0,0,1,14.887,91.584Z"
                                                transform="translate(0 -74.667)"
                                                fill="#17468f"
                                              />
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row className="mt-2 mb-3 d-flex">
                                  <Col md={12} className="text-right">
                                    <div class="forget-password-link ">
                                      {/* <a class="h6 " onClick={() => forgetToggle()}>{props.t("forgot_password")}</a> */}
                                      <a
                                        class="h6 ml-2 c-pointer"
                                        onClick={() => forgetToggle()}
                                      >
                                        {props.t("forgot_password")}
                                      </a>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={12} className="text-right">
                                    <button
                                      className="btn btn-grey w-100 "
                                      type="submit"
                                    >
                                      {props.t("login")}
                                    </button>
                                  </Col>
                                </Row>
                                <Row className="align-items-center mt-3 ">
                                  <Col md={12} className="text-center">
                                    <div class="forget-password-link d-flex justify-content-center">
                                      {/* <a class="h6 " onClick={() => forgetToggle()}>{props.t("forgot_password")}</a> */}
                                      <a
                                        class="h6 ml-2 c-pointer"
                                        onClick={() => toggleModal()}
                                      >
                                        {props.t("new_user")}{" "}
                                        {props.t("register_now")}
                                      </a>
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Nav>
              ) : (
                // {/* after login */}
                <Nav
                  className="ml-auto navbar-with-login desktop-view-after-login"
                  navbar
                >
                  <UncontrolledDropdown
                    className="navbar-notification-drp"
                    nav
                    inNavbar
                  >
                    <DropdownToggle nav className="h5 mb-0">
                      <div className="position-relative">
                        {ComonIcons.notification}
                        {props.unreadNotificationCount > 0 ? (
                          <span className="notification-counter">
                            {props.unreadNotificationCount}
                          </span>
                        ) : null}
                      </div>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <div className="notification-block">
                        <ul className="notification-wrapper">
                          {props.notifications &&
                            props.notifications.map((one, index) => {
                              return (
                                <li
                                  className={`notification-element  ${
                                    !one.isRead ? "active" : ""
                                  }`}
                                  id={index}
                                  onClick={() => {
                                    if (!one.isRead) handleMarkRead(one.id);
                                    else return;
                                  }}
                                >
                                  <div className="notification-inner-wrapper">
                                    <div className="blk-1">
                                      <img
                                        className="img-fluid"
                                        src={
                                          one.avatar ||
                                          require("../../assets/images/event.jpg")
                                        }
                                      />
                                    </div>
                                    <div className="blk-2 flex-column">
                                      <h5 className="mb-0 notification-text  f-bold">
                                        {one.title}
                                        {/* <span>{!one.isRead ? null : <p>UnRead</p>}</span> */}
                                      </h5>
                                      {/* <Link className="h5 mb-0 mt-2 f-bold">
                                  Reserve Class Now{" "}
                                </Link> */}
                                      {getNotificationLink(one)}
                                    </div>
                                  </div>
                                </li>
                              );
                            })}
                          {props.notifications &&
                          props.notifications.length <= 0 ? (
                            <div>
                              <p className="m-4">
                                {props.t("no_notification_available")}
                              </p>
                            </div>
                          ) : null}
                          {/* <li className="notification-element">
                            <div className="notification-inner-wrapper">
                              <div className="blk-1">
                                <img
                                  className="img-fluid"
                                  src={require("../../assets/images/event.jpg")}
                                />
                              </div>
                              <div className="blk-2 flex-column">
                                <h5 className="mb-0 notification-text  f-bold">
                                  Bodypump class with Dana got cancelled!
                                </h5>
                                <Link className="h5 mb-0 mt-2 f-bold">
                                  Reserve Class Now{" "}
                                </Link>
                              </div>
                            </div>
                          </li>
                          <li className="notification-element">
                            <div className="notification-inner-wrapper">
                              <div className="blk-1">
                                <img
                                  className="img-fluid"
                                  src={require("../../assets/images/event.jpg")}
                                />
                              </div>
                              <div className="blk-2 flex-column">
                                <h5 className="mb-0 notification-text  f-bold">
                                  Bodypump class with Dana got cancelled!
                                </h5>
                                <Link className="h5 mb-0 mt-2 f-bold">
                                  Reserve Class Now{" "}
                                </Link>
                              </div>
                            </div>
                          </li>
                          <li className="notification-element">
                            <div className="notification-inner-wrapper">
                              <div className="blk-1">
                                <img
                                  className="img-fluid"
                                  src={require("../../assets/images/event.jpg")}
                                />
                              </div>
                              <div className="blk-2 flex-column">
                                <h5 className="mb-0 notification-text  f-bold">
                                  Bodypump class with Dana got cancelled!
                                </h5>
                                <Link className="h5 mb-0 mt-2 f-bold">
                                  Reserve Class Now{" "}
                                </Link>
                              </div>
                            </div>
                          </li> */}
                        </ul>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <UncontrolledDropdown
                    className="navbar-profile"
                    nav
                    inNavbar
                    caret
                  >
                    <DropdownToggle nav className="h5 mb-0 p-0">
                      <div className="profile-menu-link-block">
                        <img
                          src={
                            user.image ||
                            require("../../assets/images/no_image.jpg")
                            // src={
                            //   require("../../assets/images/event.jpg")
                          }
                          className="profile-images img-fluid"
                          alt="jpg"
                        />
                      </div>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <div className="notification-block">
                        <ul className="notification-wrapper">
                          <li
                            className="profile-link"
                            onClick={() => history.push("/userinfo")}
                          >
                            <div className="d-flex align-items-center">
                              <span className="blk-1">{ComonIcons.info}</span>{" "}
                              <span className="blk-2 f-bold mb-0">
                                {props.t("my-profile")}
                              </span>
                            </div>
                          </li>
                          <li
                            className=" profile-link"
                            onClick={() => history.push("/accountinfo")}
                          >
                            <div className="d-flex align-items-center">
                              <span className="blk-1">{ComonIcons.member}</span>{" "}
                              <span className="blk-2 f-bold mb-0">
                                {props.t("my-account-info")}
                              </span>
                            </div>
                          </li>
                          <li
                            className="profile-link"
                            onClick={() => history.push("/setting")}
                          >
                            <div className="d-flex align-items-center">
                              <span className="blk-1">
                                {ComonIcons.setting}
                              </span>{" "}
                              <span className="blk-2 f-bold mb-0">
                                {props.t("setting-privacy")}
                              </span>
                            </div>
                          </li>
                          <li className="profile-link" onClick={() => logout()}>
                            <div className="d-flex align-items-center">
                              <span className="blk-1">
                                {ComonIcons.signout}
                              </span>{" "}
                              <span className="blk-2 f-bold mb-0">
                                {props.t("sign-out")}
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Nav>
              )}
            </Collapse>
          </Navbar>
        </div>
      </div>
      <Modal
        isOpen={props.loginModal}
        toggle={toggleModal}
        centered={true}
        className="medium"
        size="lg"
      >
        <ModalBody className="p-0 login-register-main-block">
          <div className="modal-body-content">
            <div className="content">
              <div className="position-relative">
                <div className="close c-pointer" onClick={toggleModal}>
                  {ComonIcons.closeSecond}
                </div>
                <TabPanel
                  toggleForgot={forgetToggle}
                  toggleLogin={toggleModal}
                  t={props.t}
                />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={forgetModal}
        toggle={forgetToggle}
        centered={true}
        className="medium delete-pop"
        size="lg"
      >
        <ModalBody className="p-0 login-register-main-block">
          <Form
            onSubmit={e => {
              e.preventDefault();
              handleForgotSubmit(e.target.email.value);
            }}
          >
            <div className="modal-body-content p-0">
              <div className="position-relative p-3 ">
                <div className="close c-pointer" onClick={forgetToggle}>
                  {ComonIcons.closeSecond}
                </div>
                <div className="content">
                  <div className="delete-title">
                    <h2 className="">{props.t("forgot_password")}</h2>
                  </div>
                  <div className="delete-data">
                    <h5>{props.t("forgot_pop_statement_1")}</h5>
                    <h5>{props.t("forgot_pop_statement_2")}</h5>
                  </div>
                  <div className="pb-0 pb-md-4">
                    <Row className="justify-content-center">
                      <Col md={6}>
                        <FormGroup className="custom-inputs mb-0">
                          <Input
                            type="email"
                            name="email"
                            id="email"
                            maxLength={50}
                            placeholder={props.t("type_in_email")}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="action-btn-block py-3">
                  <button
                    type="button"
                    value=""
                    className=" btn btn-small"
                    onClick={forgetToggle}
                  >
                    {props.t("cancel")}
                  </button>
                  <button
                    type="button"
                    className=" btn  btn-grey "
                    type="submit"
                  >
                    {props.t("send_me_otp")}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={otpModal}
        toggle={otpToggle}
        centered={true}
        className="medium delete-pop"
        size="lg"
      >
        <ModalBody className="p-0 login-register-main-block">
          <Form
            onSubmit={e => {
              e.preventDefault();
              handleOtpSubmit(e.target.otp.value);
            }}
          >
            <div className="modal-body-content p-0">
              <div className="position-relative p-3 ">
                <div className="close c-pointer" onClick={otpToggle}>
                  {ComonIcons.closeSecond}
                </div>
                <div className="content">
                  <div className="delete-title">
                    <h2 className="">{props.t("forgot_password")}</h2>
                  </div>
                  <div className="delete-data">
                    <h5>{props.t("forgot_pop_statement_1")}</h5>
                    <h5>{props.t("type_in_code")}</h5>
                  </div>
                  <div className="pb-0 pb-md-4">
                    <Row className="justify-content-center">
                      <Col md={6}>
                        <FormGroup className="custom-inputs mb-0">
                          <Input
                            type="text"
                            name="otp"
                            id="otp"
                            placeholder={props.t("type_in_code")}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="action-btn-block py-3">
                  <button
                    type="button"
                    value=""
                    className=" btn btn-small"
                    onClick={otpToggle}
                  >
                    {props.t("cancel")}
                  </button>
                  <button
                    type="button"
                    className=" btn  btn-grey "
                    type="submit"
                  >
                    {props.t("send_me_new_password")}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={regionModal}
        toggle={toggleRegionModal}
        centered={true}
        className="medium delete-pop"
        size="md"
      >
        <ModalBody className="p-0 login-register-main-block">
          <div className="modal-body-content p-0">
            <div className="position-relative p-3 ">
              <div className="close c-pointer" onClick={toggleRegionModal}>
                {ComonIcons.closeSecond}
              </div>
              <div className="content">
                <div className="delete-title">
                  <h2 className="">{props.t("select_country")}</h2>
                </div>
                <div className="pb-0 pb-md-4">
                  <Row className="justify-content-center">
                    <Col md={6}>
                      <FormGroup className="custom-inputs mb-0">
                        <ReactFlagsSelect
                          selected={region}
                          countries={["JO", "SA", "AE", "EG"]}
                          placeholder={props.t("select_country")}
                          searchPlaceholder={props.t("search")}
                          searchable
                          onSelect={val => {
                            setRegion(val);
                            setSelectedRegion(val);
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="action-btn-block py-3">
                <button
                  type="button"
                  value=""
                  className=" btn btn-small"
                  onClick={() => {
                    toggleRegionModal();
                  }}
                >
                  {props.t("proceed")}
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={props.ratingModal}
        toggle={settoggle}
        // className={className}
        centered={true}
        className="medium delete-pop"
        size="lg"
      >
        <ModalBody className="p-0 review-pop-up ">
          <div className="modal-body-content p-0">
            <div className="position-relative p-3 ">
              <div className="close c-pointer"></div>
              <div className="content">
                <div className="delete-title">
                  <h2 className="">{props.t("add_review")}</h2>
                </div>
                <div className="delete-data">
                  <h5>{props.t("add_review_statement")}</h5>
                </div>
                <div className="kettlebell-block">
                  <ul className="kettlebell-wrapper">
                    <li
                      onClick={() => setStar(1)}
                      className={`c-pointer ${
                        star >= 1 ? "kettlebell-element" : "kettlebell-disable"
                      }`}
                    >
                      {ComonIcons.startloop}
                    </li>
                    <li
                      onClick={() => setStar(2)}
                      className={`c-pointer ${
                        star >= 2 ? "kettlebell-element" : "kettlebell-disable"
                      }`}
                    >
                      {ComonIcons.startloop}
                    </li>
                    <li
                      onClick={() => setStar(3)}
                      className={`c-pointer ${
                        star >= 3 ? "kettlebell-element" : "kettlebell-disable"
                      }`}
                    >
                      {ComonIcons.startloop}
                    </li>
                    <li
                      onClick={() => setStar(4)}
                      className={`c-pointer ${
                        star >= 4 ? "kettlebell-element" : "kettlebell-disable"
                      }`}
                    >
                      {ComonIcons.startloop}
                    </li>
                    <li
                      onClick={() => setStar(5)}
                      className={` c-pointer ${
                        star >= 5 ? "kettlebell-element" : "kettlebell-disable"
                      }`}
                    >
                      {ComonIcons.startloop}
                    </li>
                  </ul>
                </div>
                <div className="pb-0 pb-md-4">
                  <Row className="justify-content-center">
                    <Col md={8}>
                      <FormGroup className="custom-inputs mb-0">
                        <Input
                          type="textarea"
                          name="reviewDetail"
                          id="trainername"
                          value={reviewDetails}
                          placeholder={props.t("review_placeholder")}
                          onChange={handleReviewDetailChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="action-btn-block py-3">
                <button
                  type="button"
                  value=""
                  className=" btn btn-small"
                  onClick={settoggle}
                >
                  {props.t("cancel")}
                </button>
                <button
                  type="button"
                  className=" btn  btn-grey "
                  onClick={handleReviewSubmit}
                >
                  {props.t("submit")}
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = state => {
  // console.log("Navbar", state);
  const { loginUser, loginFlag, country } = state.login;
  const { showCountryPopup } = state.languageDirectionData;
  const { loginModal, ratingModal, id, type } = state.modal;
  const { notifications, unreadNotificationCount } = state.notification;
  return {
    loginModal,
    loginUser,
    loginFlag,
    notifications,
    unreadNotificationCount,
    country,
    showCountryPopup,
    ratingModal,
    id,
    type
  };
};

export default connect(mapStateToProps, null)(withNamespaces()(Header));
